import { render } from "./DelegationReasons.vue?vue&type=template&id=4c125b04"
import script from "./DelegationReasons.vue?vue&type=script&lang=js"
export * from "./DelegationReasons.vue?vue&type=script&lang=js"

import "./DelegationReasons.vue?vue&type=style&index=0&id=4c125b04&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__